export default __webpack_public_path__ + "static/app-features-6--mobile-543850d462941b1d4a7e44bc3a83f6bb.png";